module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Italic-VariableFont_wght.c6bd3951.ttf";